import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import CEditor from 'src/components/editor/CEditor';
import { RHFTextField } from 'src/components/hook-form';
import { UploadErrorMessage } from 'src/components/hook-form/UploadErrorMessage';
import RHFUploadImage from 'src/components/hook-form/uploadImage/RHFUploadImage';
import { FormInnerContainer, FormItem, FormLabel, FormRow } from 'src/layouts/form/FormLayout';

export const Contents = observer(() => {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const [files, setFiles] = useState<Array<File | string>>([]);

  useEffect(() => {
    setFiles(getValues('detailPath'));
  }, []);

  return (
    <FormInnerContainer>
      <FormLabel>{t('common.form.section.content')}</FormLabel>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <RHFTextField label={t('business.form.title')} name="title" />
        </FormItem>
      </FormRow>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <RHFTextField label={t('business.form.summary')} name={'summary'} multiline rows={3} />
        </FormItem>
      </FormRow>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <CEditor name={'desc'} placeholder={t('business.form.desc')} />
        </FormItem>
      </FormRow>
      <FormInnerContainer>
        <FormLabel>{t('business.form.detailImage')}</FormLabel>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFUploadImage
              name="detailPath"
              maxFiles={8}
              files={files}
              onChange={(newFile: Array<File | string>) => {
                setFiles(newFile);
                setValue('detailPath', newFile, {
                  shouldValidate: true,
                  shouldDirty: true,
                });
              }}
            />
            {errors.detailPath?.message && (
              <UploadErrorMessage message={String(errors.detailPath.message)} />
            )}
          </FormItem>
        </FormRow>
      </FormInnerContainer>
    </FormInnerContainer>
  );
});
